export class CookieChecker {    

    constructor() {
        this.sessionCookieCheckAlreadyPerformed = false
        this._supportsSessionCookiesInternal = false        
    }

    supportsSessionCookies() {
        if (this.sessionCookieCheckAlreadyPerformed)
            return this._supportsSessionCookiesInternal;

        var cookieName = 'SessionCookieTest';

        try {
            Cookies.set(cookieName, 'test');
            if (Cookies.get(cookieName) == 'test')
                this._supportsSessionCookiesInternal = true;            
        }
        finally {
            this.sessionCookieCheckAlreadyPerformed = true;
            Cookies.remove(cookieName);
        }

        return this._supportsSessionCookiesInternal;
    }
}